(function () {
  'use strict';
  function init(root) {
    if (root.dataset.yhwl26Initialized === 'true') return;
    root.dataset.yhwl26Initialized = 'true';
    const toast = root.querySelector('[data-yhwl26-toast]');
    const cartUrl = root.dataset.cartUrl || '/cart';
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || root.dataset.rootUrl || '/';
    const cartRoot = base.endsWith('/') ? base : base + '/';
    let busy = false;
    let toastTimeout;
    function notice(message, viewCart) {
      if (!toast) return;
      toast.textContent = message;
      if (viewCart) {
        const anchor = document.createElement('a');
        anchor.href = cartUrl;
        anchor.textContent = ' View Cart';
        toast.append(anchor);
      }
      toast.hidden = false;
      clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => { toast.hidden = true; }, 5500);
    }
    async function updateCartCount() {
      try {
        const res = await fetch(cartRoot + 'cart.js', { credentials: 'same-origin' });
        if (!res.ok) return;
        const cart = await res.json();
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (bubble) {
          bubble.querySelectorAll('span').forEach(el => { if (!el.classList.contains('visually-hidden')) el.textContent = cart.item_count; });
          const hidden = bubble.querySelector('.visually-hidden');
          if (hidden) hidden.textContent = cart.item_count + ' items';
        }
        // Existing Dawn cart drawer/notification refreshes fully after normal cart navigation.
      } catch (e) { /* Counter update is non-critical */ }
    }
    async function addItems(items, button) {
      if (busy || !items.length) { if (!items.length) notice('Choose at least one available product.'); return; }
      busy = true;
      if (button) button.disabled = true;
      try {
        const response = await fetch(cartRoot + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        notice(items.length > 1 ? 'Outfit items added to your cart.' : 'Item added to your cart.', true);
        updateCartCount();
      } catch (err) { notice(err.message || 'Could not add to cart. Please try again.'); }
      finally { busy = false; if (button) button.disabled = false; }
    }
    root.querySelectorAll('[data-yhwl26-item]').forEach(card => {
      const button = card.querySelector('[data-yhwl26-add-one]');
      if (button) button.addEventListener('click', () => {
        const variant = card.querySelector('[data-yhwl26-variant]');
        if (variant && variant.value) addItems([{ id: Number(variant.value), quantity: 1 }], button);
      });
    });
    const bundle = root.querySelector('[data-yhwl26-add-selected]');
    if (bundle) bundle.addEventListener('click', () => {
      const items = [];
      root.querySelectorAll('[data-yhwl26-item]').forEach(card => {
        const checkbox = card.querySelector('[data-yhwl26-selected]');
        const variant = card.querySelector('[data-yhwl26-variant]');
        if (checkbox && checkbox.checked && variant && variant.value) items.push({ id: Number(variant.value), quantity: 1 });
      });
      addItems(items, bundle);
    });
    root.querySelectorAll('[data-yhwl26-hotspot]').forEach(spot => {
      spot.addEventListener('click', () => {
        const target = root.querySelector('[id="yhwl26-item-' + CSS.escape(spot.dataset.yhwl26Hotspot) + '"]');
        if (!target) return;
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        root.querySelectorAll('.yhwl26__highlight').forEach(x => x.classList.remove('yhwl26__highlight'));
        target.classList.add('yhwl26__highlight');
        setTimeout(() => target.classList.remove('yhwl26__highlight'), 2400);
      });
    });
  }
  function mount() { document.querySelectorAll('[data-yhwl26-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
